import dayjs from 'dayjs';

export function formatDate(dateString: string | undefined | null): string {
  if (!dateString) return '-';
  const date = dayjs(dateString);
  if (!date.isValid()) return '-';
  return date.format('DD.MM.YYYY');
}
